<script>
import { unitToString } from '@/utils/price';

export default {
  name: 'Minimumcommitmentperiod',

  functional: true,

  props: {
    unit: {
      type: Number,
      required: false,
      default: null,
    },

    factor: {
      type: Number,
      required: false,
      default: null,
    },
  },

  render: (h, ctx) => {
    const { unit, factor } = ctx.props;

    if (!factor) return h('span', ctx.parent.$t('common.no_minimum_contract_period')); // #S824

    const content = `${factor} ${ctx.parent.$t(`common.${unitToString(unit, factor)}`)}`;
    return h('span', content);
  },
};
</script>
